(ns frontend.ux-overhaul.listing.task.event
  (:require [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.view.modals.activity-entity-editor.view :as activity-entity-editor]
            [frontend.view.modals.events :as modals]
            [re-frame.core :as rf]
            [ui.completion.event :as completion-event]
            [ui.view.grid-opensearch.event :as grid-event]
            [ui.view.kanban-opensearch.event :as kanban-event]))

(rf/reg-event-fx
 ::refresh-listing
 (fn [_ [_ {:keys [listing-id]}]]
   ;; The rows and cards come from OpenSearch. After a write, query again. The
   ;; event has a name so that it can be the `:on-complete` of one `::await`.
   {:fx [[:dispatch [::grid-event/trigger-query-search (str listing-id "-grid")]]
         [:dispatch [::kanban-event/reload-visible-columns
                     {:kanban-id (str listing-id "-kanban")}]]]}))

(rf/reg-event-fx
 ::task-saved
 (fn [_ [_ {:keys [listing-id response]}]]
   ;; The task editor saves with a call that rebuilds the index on another thread.
   ;; The call returns a completion id. Query again when the rebuild is complete.
   ;; Otherwise the listing shows the old row.
   {:fx [[:dispatch [::completion-event/await
                     {:completion-id (:completion/id response)
                      :on-complete   [::refresh-listing {:listing-id listing-id}]}]]]}))

(rf/reg-event-fx
 ::create-task
 (fn [_ [_ {:keys [listing-id]}]]
   (modals/open-modal! activity-entity-editor/modal-key
                       (cond-> {:new-entity-type :entity.type/task}
                         listing-id
                         (assoc :on-success-callback!
                                (fn [response]
                                  (rf/dispatch [::task-saved {:listing-id listing-id
                                                              :response   response}])))))
   {}))

(rf/reg-event-fx
 ::open-bulk-edit
 (fn [_ [_ {:keys [listing-id]}]]
   (rf/dispatch [::bulk-actions/open-bulk-edit {:listing-id listing-id}])
   {}))

(rf/reg-event-fx
 ::bulk-delete-selected
 (fn [{:keys [db]} [_ {:keys [listing-id]}]]
   (bulk-actions/bulk-delete-selected!
    {:db        db
     :listing-id listing-id
     :operation :task/mass-action
     :body-fn   (fn [ids]
                  {:action   :delete-tasks
                   :task-ids ids})})
   {}))

(rf/reg-event-fx
 ::export-grid
 (fn [_ [_ {:keys [listing-id]}]]
   (bulk-actions/export-grid! {:listing-id  listing-id
                               :entity-type :entity.type/task})
   {}))
